const Promise = window.Promise;
export { Promise };